<div class="landing-page">
    <app-header></app-header>
    <main>
        <div class="main-content">

            <h1 class="heading">Dentist support</h1>
            <p class="subtext">To search for a dentist, enter Npi.</p>
            <form [formGroup]="adminSearchForm">
                <div class="search-row">
                    <app-text-input aria-label="To search for a dentist enter Npi" class="sarch-text"
                        [control]="adminSearchForm.controls['searchText']" [for]="'adminSearch-Input'"
                        [errorMessages]="customErrorMessages" id="txtAdminSeach" (keypress)="restrictNonNumeric($event)"></app-text-input>
                    <app-button class="btn-mgr search-btn-claim" label="Search" [isFilled]="false"
                        [buttonType]="'primary'" (click)="submitSearch()" id="btnAdminSearch"></app-button>
                </div>
            </form>

            <div class="viewtable-outer-box">
                @if(!dataSource.data.length && isSubmitted){
                <div class="no-data-message">
                    No results found
                </div>
                }@else if(dataSource.data.length){
                <!-- ------desktop only----------->
                <div class="pagination-example desktop-only">
                    <app-table class="list-table table-wrapper1 arrow-block adminsearch-table" [data]="dataSource.data"
                        [paginator]="paginator" [columns]="tableColumns" id="tblAdmin"
                        (clickEvent)="onTableClick($event)">
                    </app-table>

                    <mat-paginator [length]="totalRecords" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"
                        aria-label="Select page" (page)="onPageChange($event)">
                    </mat-paginator>
                </div>

                <!-- --------mobile only------------>
                <div class="cards-container mobile-only" *ngIf="dataSource.data.length > 0">
                    <div class="participation-card" *ngFor="let item of dataSource.data">
                        <div class="card-row">
                            <span class="card-label">Last name</span>
                            <span class="card-value name-value">{{ item.lastName }}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">First name</span>
                            <span class="card-value">{{ item.firstName }}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">Username</span>
                            <span class="card-value">{{ item.username }}</span>
                        </div>
                        <div class="card-row">
                            <span class="card-label">Action</span>
                            <button class="btn-recred" (click)="onTableClick(item.userId)">Impersonate</button>
                        </div>
                    </div>
                </div>

                }
            </div>

        </div>


        <div *ngIf="isLoading" class="loader-overlay">
            <div class="loader"></div>
        </div>
    </main>
    <app-footer-layout></app-footer-layout>
</div>